module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/tradingbg-e07df38e20aa537625cafcfc6d0d6e23.png";